$(function () {
  let section = $('#seccionCupones')
  if (section.get(0) == null) {
    return
  }
  let vueApp = new Vue({
    el: section.get(0),
    data: {
      loader: false,
      filtros: { page: 1, buscar: null, tipo: null },
      cupones: [],
      modalTitulo: 'Nuevo cupón',
      cupon: {
        productos_id: []
      },
      productos: productosJson
    },
    mounted() {
      this.getCupones()
    },
    methods: {
      getCupones(pagina = null) {
        if (this.loader) {
          return
        }
        if (pagina != null) {
          this.filtros.page = pagina
        }
        this.loader = true
        axios
          .get('/admin/cupones/json', {
            params: this.filtros,
          })
          .then((response) => {
            vueApp.loader = false
            if (response.data.error) {
              swal(respuesta.data.error, "", "info")
              return
            }
            vueApp.cupones = response.data.cupones.data;
            vueApp.filtros.total = response.data.cupones.total;
            vueApp.filtros.per_page = response.data.cupones.per_page;
            vueApp.filtros.from = response.data.cupones.from;
            vueApp.filtros.to = response.data.cupones.to;
          })
          .catch((error) => {
            vueApp.loader = false
            console.log(error)
            swal("Ocurrió un error inesperado", "", "info")
          })
      },
      eliminar(id) {
        swalQ("¿Eliminar registro?", "", "warning").then((ok) => {
          if (ok) {
            axios
              .delete('/admin/cupones/' + id)
              .then(function (response) {
                if (response.data.error) {
                  swal(respuesta.data.error, "", "info")
                  return
                }
                vueApp.getCupones(1)
              })
              .catch((error) => {
                console.log(error)
                swal("Ocurrió un error inesperado", "", "info")
              })
          }
        })
      },
      agregar(){
        this.cupon = Object.assign({}, {
          productos_id: [],
          tipo: 'c'
        })
        this.modalTitulo = 'Nuevo cupón'
        $('#modalCupon').modal('show')
        this.validar()
      },
      validar() {
        $('#formCupon').validarForm((form) => {
          vueApp.guardar(form)
        })
        $('#formCupon')[0].reset()
      },
      guardar(form) {
        $('#btnGuardar').loader('show')
        let formData = new FormData(form)
        if(this.cupon.fecha_inicio != null){
          formData.append("fecha_inicio", this.cupon.fecha_inicio)
        }
        if(this.cupon.fecha_fin != null){
          formData.append("fecha_fin", this.cupon.fecha_fin)
        }
        axios
          .post('/admin/cupones/guardar', formData)
          .then((respuesta) => {
            $('#btnGuardar').loader('hide')
            if (respuesta.data.error) {
              swal(respuesta.data.error, "", "info")
              return
            }
            $('#modalCupon').modal('hide')
            vueApp.getCupones(1)
          })
          .catch((error) => {
            console.log(error)
            $('#btnGuardar').loader('hide')
            swal("Ocurrió un error inesperado", "", "info")
          })
      }
    },
  })
})
